import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteVariableCategoryValue } from 'store/data/variables';

type HandlerInput = Parameters<typeof deleteVariableCategoryValue>[0];

export function useDeleteVariableCategoryValue(): Operation<(input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(
		ActionTypes.DELETE_VARIABLE_CATEGORY_VALUE
	);

	function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(deleteVariableCategoryValue(input));
	}

	return [{ loading, error }, handler];
}
